import { render, staticRenderFns } from "./JuniorTrackingScores.vue?vue&type=template&id=8888bca4"
import script from "./JuniorTrackingScores.vue?vue&type=script&lang=ts"
export * from "./JuniorTrackingScores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports